import React from 'react';

import Home from './Home';
import About from './About';
import Benefits from './Benefits';
import SimulateNow from './SimulateNow';
import Faq from './Faq';

import './styles.scss';
import '../../styles/alert.scss';

function Consignado() {
    return (
        <>
            <Home />
            <About />
            <Benefits />
            <SimulateNow />
            <Faq />
        </>
    )
}

export default Consignado;
